import Swiper from 'swiper/bundle';

if ($(".slider-type-5.swiper-container").length > 0) {
    const slider_type_5_swiper = new Swiper(".slider-type-5.swiper-container", {
        slidesPerView: 'auto',
        loop: false,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        navigation: {
            nextEl: ".section-slider-type-5 .swiper-button-next.slider-type-5-swiper-button",
            prevEl: ".section-slider-type-5 .swiper-button-prev.slider-type-5-swiper-button",
        },
        pagination: {
            el: ".section-slider-type-5 .swiper-pagination",
            clickable: true,
        },

    });

}